
import { motion } from 'framer-motion';
import { Brain, Sparkles } from 'lucide-react';
import { CardHeader, CardTitle, CardDescription } from '@/components/ui/card';

interface AnalysisCardHeaderProps {
  title: string;
  description: string;
  isGenerating: boolean;
}

export function AnalysisCardHeader({ title, description, isGenerating }: AnalysisCardHeaderProps) {
  return (
    <CardHeader className="text-center">
      <div className="flex justify-center mb-3">
        <motion.div
          animate={isGenerating ? { rotate: 360 } : {}}
          transition={{ duration: 2, repeat: isGenerating ? Infinity : 0, ease: "linear" }}
          className="p-3 bg-gradient-to-br from-purple-100 to-blue-100 rounded-full"
        >
          <Brain className="h-8 w-8 text-purple-600" />
        </motion.div>
      </div>
      <CardTitle className="flex items-center justify-center gap-2">
        <Sparkles className="h-5 w-5 text-purple-600" />
        {title}
      </CardTitle>
      <CardDescription className="text-base">{description}</CardDescription>
    </CardHeader>
  );
}
